import { Kaggle } from "@kaggle/sdk";
import { NotebookActionKey } from "../../../actions/ActionKeys";
import { NotebookAction } from "../../../actions/notebook";

type Tag = Kaggle.Sdk.Tags.Tag;

export const tags = (state: Tag[] | null = null, action: NotebookAction) => {
  switch (action.type) {
    case NotebookActionKey.SET_TAGS:
      return action.payload.tags;
    default:
      return state;
  }
};
